import { apiRequests } from "../services/api";
import { GET_REPORTSUBSCRIPTION , GET_REPORTTECHNICIANS} from "../graphql/query/report/query";

export const reportSubscription = async(filters={}) => {
    try {
      //console.log('1234567890', filters);
        const normalizedFilters = {
            startDate: filters.startDate || "",
            endDate: filters.endDate || "",
            type: filters.type || "",
            state: filters.state !== undefined ? String(filters.state) : "",
            status: filters.status !== undefined ? filters.status : null ,
          };
      //console.log('121111111', normalizedFilters);
          const variables = {
            Input: normalizedFilters
          };
          //console.log('123',variables);
          const response = await apiRequests(GET_REPORTSUBSCRIPTION,variables);
         
          return response.data.reportSuscription;
          
    } catch ( err ) {
        console.warn('Fallas en el servidor: ' , err );
        return null;
    }
}

export const reportTechnician = async(filters={}) => {
  try{
    const normalizedFilters = {
      skills: filters.skills || "",
      cities: filters.cities || "",
      rates: filters.rates || "",
      status: filters.status !== undefined ? filters.status : null ,
    };
    //console.log(normalizedFilters);
    const variables = { Input: normalizedFilters };
    const response = await apiRequests(GET_REPORTTECHNICIANS,variables);
    return response.data.reportTechnician;
  } catch ( err ) {
    console.warn('Fallas en el servidor: ' , err );
    return null;
  }
}